import React from 'react'
import { Box, Button } from '@mui/material'

import { QRType } from '../../../../types.ts'
import { useDialog } from '../../../../hooks'

import { NewB2BForm } from './new-b2b-form.tsx'
import { NewC2BForm } from './new-c2b-form.tsx'
import { useAppSelector } from '@/stores/hooks.ts'

export interface CreateQrButtonProps {
  type: QRType
  title: string
}

export const CreateQrButton = ({ type, title }: CreateQrButtonProps): React.ReactElement | null => {
  const { showDialog, handleHideDialog, handleShowDialog } = useDialog()
  const showQrC2b = useAppSelector((state) => state.user.user?.permissions?.showQrC2b)

  const Dialog = type === 'B2B' ? NewB2BForm : NewC2BForm

  // эта проверка нужна тк на одной странице у нас функционал и по статическим и по динамическим куарам
  const showCreateDynamicC2B = (type === 'C2B' && showQrC2b) || type === 'B2B'
  if (!showCreateDynamicC2B) return null

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button onClick={handleShowDialog}>{title}</Button>
      {showDialog && <Dialog open={showDialog} onClose={handleHideDialog} />}
    </Box>
  )
}
